<template>
  <SinglePartner />
</template>

<script>
import SinglePartner from '@/components/content/partners/EditSelectedPartner.vue'

export default {
  name: 'ContentPartner',
  components: { SinglePartner }
}
</script>

<style scoped>

</style>
